import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArchive1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"archive-1, inbox, file"} maskId="square-filled-radius-0-stroke-1-IconArchive1"><path d="M22 3H2V7H22V3Z" fill="currentColor"/><path fillRule="evenodd" clipRule="evenodd" d="M21 8H3V21H21V8ZM9.5 11H14.5V12H9.5V11Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArchive1;
